(function () {
  function getOptionValues(variant) {
    if (!variant || !Array.isArray(variant.options)) return [];
    return variant.options.map(function (value) {
      return (value || '').toString().trim().toLowerCase();
    });
  }

  function applyVisibility(variant) {
    var mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    var selectedValues = getOptionValues(variant);
    var items = mediaGallery.querySelectorAll('[data-variant-tag]');
    var firstVisibleId = null;

    items.forEach(function (item) {
      var tag = (item.dataset.variantTag || '').toLowerCase();
      var show = tag === '' || selectedValues.indexOf(tag) !== -1;
      item.classList.toggle('variant-media-hidden', !show);
      if (show && !firstVisibleId && item.dataset.mediaId) {
        firstVisibleId = item.dataset.mediaId;
      }
    });

    var activeSlide = mediaGallery.querySelector('.product__media-item.is-active');
    if (activeSlide && activeSlide.classList.contains('variant-media-hidden') && firstVisibleId) {
      mediaGallery.setActiveMedia(firstVisibleId, false);
    }
  }

  function getInitialVariant() {
    var script = document.querySelector('variant-selects [data-selected-variant]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyVisibility(getInitialVariant());
  });

  // Le thème publie cet événement une fois la galerie mise à jour après un changement de variante
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      applyVisibility(event.data.variant);
    });
  }
})();